<div class="row justify-content-center mt-5">
  <div class="col-12 col-sm-8 col-md-6 col-lg-4">
    <app-panel>
      <div panel-content class="pt-4 pb-4">
        <h2 class="text-center">{{'MFA.OTP_TITLE'|translate}}</h2>
        <p class="text-center mt-3">{{'MFA.OTP_INTRO'|translate}}</p>

        <form (ngSubmit)="onSubmit()">
          <input #codeInput
                 type="text"
                 class="form-control form-control-lg text-center"
                 style="letter-spacing:8px;font-size:28px"
                 [(ngModel)]="code"
                 (ngModelChange)="onCodeInput()"
                 name="code"
                 inputmode="numeric"
                 autocomplete="one-time-code"
                 maxlength="6"
                 placeholder="000000"
                 [disabled]="isLoading">

          <div *ngIf="codeError" class="scg-note-error mt-3 text-center">
            {{'MFA.ERROR_CODE'|translate}}
          </div>

          <button type="submit" class="btn btn-primary btn-block mt-4"
                  [disabled]="isLoading || code.length < 6">
            {{'MFA.OTP_SUBMIT'|translate}}
          </button>
        </form>

        <div class="text-center mt-3">
          <button type="button" class="scg-link-native" (click)="onCancel()">{{'MFA.OTP_CANCEL'|translate}}</button>
        </div>
      </div>
    </app-panel>
  </div>
</div>
